import { root } from './upload';

export const upload = {
  ...root,
};
